export const personalDataContentId = 'main-content';

export const personalDataStepperTopPadding = 8;
export const personalDataStepperMaxLayoutAttempts = 12;
export const personalDataStepperCorrectionDelayMs = 300;

export const personalDataBottomActionInFlowMaxHeight = 450;
export const personalDataBottomActionViewportCheckDelaysMs = [0, 120, 300, 600, 1000];
